import { FmsNotificationRouteSync } from 'components/FmsNotifications/FmsNotificationRouteSync'
import { Header } from 'components/Header/Header'
import { FmsNotificationsProvider } from 'context/FmsNotificationsContext'
import { useUser } from 'hooks/user'
import { Outlet } from 'react-router-dom'

import style from './Layout.module.css'

function MainPageLayout() {
  const user = useUser()
  const notificationsEnabled = Boolean(user?.state.userLoggedIn)

  return (
    <FmsNotificationsProvider enabled={notificationsEnabled}>
      <FmsNotificationRouteSync />
      <div className={style.header}>
        <Header.Main />
      </div>
      <div className={style.container}>
        <Outlet />
      </div>
    </FmsNotificationsProvider>
  )
}

function PublicPageLayout() {
  return (
    <>
      <div className={style.header}>
        <Header.Public />
      </div>
      <div className={style.container}>
        <Outlet />
      </div>
    </>
  )
}

function FullscreenPageLayout() {
  const user = useUser()
  const notificationsEnabled = Boolean(user?.state.userLoggedIn)

  return (
    <FmsNotificationsProvider enabled={notificationsEnabled}>
      <FmsNotificationRouteSync />
      <div className={style.header}>
        <Header.Main />
      </div>
      <div className={style.containerFullscreen}>
        <Outlet />
      </div>
    </FmsNotificationsProvider>
  )
}

export const Layout = {
  MainPage: MainPageLayout,
  PublicPage: PublicPageLayout,
  FullscreenPage: FullscreenPageLayout,
}
